import { render, staticRenderFns } from "./WhyKwanzaa.vue?vue&type=template&id=3de3c08d&scoped=true&"
import script from "./WhyKwanzaa.vue?vue&type=script&lang=js&"
export * from "./WhyKwanzaa.vue?vue&type=script&lang=js&"
import style0 from "./WhyKwanzaa.vue?vue&type=style&index=0&id=3de3c08d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de3c08d",
  null
  
)

export default component.exports